"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFullWidthCharacterStrLength = void 0;

var getFullWidthCharacterStrLength = function getFullWidthCharacterStrLength(str) {
  if (str === void 0) {
    str = '';
  }

  var len = 0;
  var length = (str === null || str === void 0 ? void 0 : str.length) || 0;

  for (var i = 0; i < length; i++) {
    var charCode = str.charCodeAt(i); // 零宽空白，无需统计宽度

    if (charCode === 8203) {
      continue;
    }

    if (charCode <= 127) {
      len += 1;
    } else {
      len += 2;
    }
  }

  len = Math.ceil(len / 2);
  return len;
};

exports.getFullWidthCharacterStrLength = getFullWidthCharacterStrLength;